/* eslint-disable no-console */
import React, { useState, useEffect, useRef } from "react";

import { Link, navigate } from "@reach/router";
import styled from "@emotion/styled";
import produce from "immer";
import useWindowDimensions from "../hooks/useWindowDimensions";
import axios from "axios";
import moment from 'moment';
import Modal from "../newcomponents/optioncomponents/Modal";
import ArrayBar from "../newcomponents/optioncomponents/ArrayBar";
import CheckoutPanel from "../newcomponents/CheckoutPanel";
import ConfirmCheckOutModal from '../newcomponents/optioncomponents/ConfirmCheckoutModal';
import TakeAwayModal from '../newcomponents/optioncomponents/TakeAwayModal';
import DeliveryOrNotModal from '../newcomponents/optioncomponents/DeliveryOrNotModal';
import PaymentTypeModal from '../newcomponents/optioncomponents/PaymentTypeModal'
import { IoIosArrowBack } from "react-icons/io";

import { UserContext, ActionContext, ThemeContext, LanguageContext } from "../contexts/Context";
import EditItemModal from '../newcomponents/EditItemModal';

import Loader from "react-loader-spinner";

const Checkout = () => {
  //component ref
  const orderRef = useRef(null);
  const asiaPaySubmit = useRef(null);

  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showTk, setShowTk] = useState(false);
  const [showDelive, setShowDelive] = useState(false);
  const [deliveryType, setDeliveryType] = useState(0);
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const [showPayment, setShowPayment] = useState(false);
  const [payType, setPayType] = useState(0);
  const [error, setError] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [editIndex, setEditIndex] = useState(0);
  const [editItem, setEditItem] = useState(null);
  //Hook
  const { height, width } = useWindowDimensions();
  //Passing Props Form
  //   const { menuSelectionFormRef } = location.state;
  //State
  const [arrayBarState, setArrayBarState] = useState([
    { itemOptionId: 0, title: "Cart", title2: "菜单", active: true, menuTitle: "CURRENT ORDER", menuTitle2: "当前订单" },
    { itemOptionId: 1, title: "Review Order", title2: "查看已下订单", active: false, menuTitle: "REVIEW ORDER HISTORY", menuTitle2: "查看已下订单" },
  ]);

  const [cartHistory, setCartHistory] = useState([]);
  const [isLoading, setLoading] = useState(false);
  //Context
  const {
    pax,
    cart,
    token,
    userId,
    orderTime,
    company,
    tax,
    paymentData,
    isTakeAway,
    hasPayment,
    paymentPlatform,
    isDemo,
    lanIndex,
    currencySymbol,
    allowTAafterWH,
    startTime,
    endTime,
    otherUrls,
    deliveryOrNot,
    deliveryCosts,
    minimumConsumption,
    PaymentTakeawayOnly,
    haveToPayOnline,
    isOnlinePayMinConsumption,
    onlinePayMinConsumptionVal,
    includeDineIn,
    tkDiMenuDiff,
    tkType,
    adCustomer
  } = React.useContext(UserContext);
  const { clearCart, removeFromCart, addToCart } = React.useContext(ActionContext);
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  //filter menu
  useEffect(() => {
    let checkinTime = localStorage.getItem("checkIn");
    if (checkinTime) {
      let diff = (new Date().getTime() - checkinTime) / 1000 / 60 / 60;

      if (diff > 1) {
        window.location.replace(otherUrls && otherUrls.length > 0 ? otherUrls[0].url : "https://google.com");
      }
    }

    if (isTakeAway && !allowTAafterWH) {
      let stime = moment(startTime);
      let etime = moment(endTime);
      let st = moment().set("hour", stime.get("hour")).set("minute", stime.get("minute"));
      let et = moment().set("hour", etime.get("hour")).set("minute", etime.get("minute"));
      if (stime.get("hour") < etime.get('hour')) {
        et = et.add(24, "hour");
      }
      if (moment().isBefore(st) || moment().isAfter(et)) {
        window.location.replace(otherUrls && otherUrls.length > 0 ? otherUrls[0].url : "https://google.com");
      }
    }
    if (isTakeAway) {
      setDeliveryType(tkType);
    }
  }, [isTakeAway]);

  //Methods
  //Remove from cart
  const handleDelete = (cart, index) => {

    cart.splice(index, 1);
    localStorage.setItem("order", JSON.stringify(cart));
    removeFromCart(cart, index);
    //useEffect hook dependency cant be from outerscope, aka "cart" form UserContext
    //so we manually have to update subtotal here every removal
    setSubtotal(getFinalPrice(cart));
  };

  const handleAdd = (cart, index) => {
    cart[index].qty += 1;
    if (cart[index].qty == 0) {
      cart.splice(index, 1);
    }
    localStorage.setItem("order", JSON.stringify(cart));
    removeFromCart(cart, index);
    setSubtotal(getFinalPrice(cart));
  }
  const handleItemClick = (item, index) => () => {
    setEditIndex(index);
    setEditItem(JSON.parse(JSON.stringify(item)));
    setShowEdit(true);
  };
  const handleMinus = (cart, index) => {
    cart[index].qty -= 1;
    if (cart[index].qty == 0) {
      cart.splice(index, 1);
    }
    localStorage.setItem("order", JSON.stringify(cart));
    removeFromCart(cart, index);
    setSubtotal(getFinalPrice(cart));
  }
  //Produce State Draft
  const produceArrayStateSingle = produce((draft, itemOptionId) => {
    //For State
    draft.forEach((element) => {
      element.active = false;
    });
    const foundActive = draft.find((item) => item.itemOptionId === itemOptionId);
    foundActive.active = !foundActive.active;
  });

  //Return "Order History Review" or "Order Review"
  const returnMenuTitle = () => {
    const foundActive = arrayBarState.find((item) => item.active === true);
    return lanIndex === 0 ? foundActive.menuTitle : foundActive.menuTitle2;
  };

  const getFinalPrice = (cart) => {

    let subtotal = 0;

    cart.forEach((item) => {
      let price = item.price;
      if (item.fixedPrice) {
        subtotal = subtotal + price * item.qty;
        return;
      }

      item.optionArray.forEach((element) => {
        if (element.optionType === 0) {
          let selectedOption = element.options.find(
            (selected) => selected.active === true
          );
          price = price + (selectedOption && selectedOption.addPrice
            ? selectedOption.addPrice * (selectedOption.qty ? selectedOption.qty : 1)
            : 0);
        } else if (element.optionType === 3) { //set meal
          if (element.optionActive === true) {
            let foundOptionsActive = element.options.find(
              (optionsSelection) => optionsSelection.active === true
            );
            price = price +
              (foundOptionsActive && foundOptionsActive.price
                ? foundOptionsActive.price
                : 0);

            if (foundOptionsActive) {
              foundOptionsActive.optionArray.forEach((element) => {
                element.options.forEach((it) => {
                  if (it.active) {
                    if (it.price) {
                      price += it.price;
                    } else if (it.addPrice) {
                      price += it.addPrice * (it.qty ? it.qty : 1);
                    }
                  }
                })
              });
            }
          }
        } else {
          const filteredArray = element.options.filter(
            (item) => item.active === true
          );
          filteredArray.forEach((item) => {
            price = price + item.addPrice * (item.qty ? item.qty : 1);
          });
        }
      });
      subtotal = subtotal + price * item.qty;
    });
    return subtotal;
  };

  const [subtotal, setSubtotal] = useState(getFinalPrice(cart));

  const [subtotalHistory, setSubtotalHistory] = useState(
    getFinalPrice(cartHistory)
  );
  const notAllowToCheck = () => {
    setError([{
      errorElement: "No Item Selected",
      errorMessage: (
        <b style={{ color: "#CF000D" }}>{languageContext[lanIndex].pleaseSelectItem}</b>
      )
    }])
    setShow(true);

  }
  const minimumConsumptionTip = () => {
    setError([{
      errorMessage: (
        <b style={{ color: "#CF000D" }}>{`${languageContext[lanIndex].minimumConsumptionTip} ${minimumConsumption}`} </b>
      )
    }])
    setShow(true);

  }
  const hasExceedMax = () => {
    let obj = {};
    for (let item of cart) {
      if (!obj[item.codeId]) {
        obj[item.codeId] = item;
      } else {
        obj[item.codeId].qty += item.qty;
      }
    }

    for (let key in obj) {
      if (obj[key].hasLimitQty && obj[key].qty > obj[key].maxQty) {
        setError([{
          errorElement: "Exceed Limit",
          errorMessage: (
            <b style={{ color: "#CF000D" }}>{obj[key].title} exceed Max. ({obj[key].maxQty}) Qty </b>
          )
        }])
        setShow(true);
        return true;
      }
    }

    return false;
  }

  const sendOrder = async () => {
    //check if demo
    if (isDemo) return;
    if (hasExceedMax()) return;
    //check if has item
    if (cart.length == 0) {
      notAllowToCheck();
      return;
    }



    if (isTakeAway) { //TakeAway
      if (hasPayment) { //check if has exceed min. spending amt
        if (isOnlinePayMinConsumption && subtotal < onlinePayMinConsumptionVal) {
          setError([{
            errorElement: languageContext[lanIndex].belowMinSpendning,
            errorMessage: (
              <b style={{ color: "#CF000D" }}>{languageContext[lanIndex].belowMinSpending2}<br />
                {languageContext[lanIndex].belowMinSpending3 + " " + currencySymbol + onlinePayMinConsumptionVal.toFixed(2)}</b>
            )
          }])
          setShow(true);
          return;
        }
      }

      if ((deliveryOrNot && tkType == 0) || (includeDineIn && !tkDiMenuDiff)) { //商家是否开通外卖 
        return setShowDelive(true); // 询问TakeAway or delivery
      } else {
        return setShowTk(true);  // 填写联系方式
      }
    } else { // dine in
      if (hasPayment && !PaymentTakeawayOnly) { // Payment Integration
        if (haveToPayOnline) {//必须 paynow
          confirmPTCheckOut(0);
        } else {
          setShowPayment(true); //询问paynow or paylater
        }
      } else { // 去付款
        setShowConfirm(true)
      };
    }
  }

  const confirmToCheckout = async () => {
    setLoading(true);
    let order = { pax: pax, data: cart, orderId: "SO_" + new Date().getTime(), customerName: "", phone: "", userId: userId, adCustomer };
    await sendOrderToServer(order);
  }
  const confirmPTCheckOut = async (payType) => {
    if (payType == 0) { //online payment
      //double check if totalAmount is greater than minConsumption
      if (isOnlinePayMinConsumption && subtotal < onlinePayMinConsumptionVal) {
        setError([{
          errorElement: languageContext[lanIndex].belowMinSpendning,
          errorMessage: (
            <b style={{ color: "#CF000D" }}>{languageContext[lanIndex].belowMinSpending2}<br />
              {languageContext[lanIndex].belowMinSpending3 + " " + currencySymbol + onlinePayMinConsumptionVal.toFixed(2)}</b>
          )
        }])
        setShow(true);
        return;
      }
      setLoading(true);
      let order = { pax: pax, data: cart, orderId: "SO_" + new Date().getTime(), customerName: "", phone: "", userId: userId, adCustomer };
      await sendOrderToPayment(order);
    } else { //pay later
      setShowConfirm(true)
    }
  }
  const confirmTKCheckOut = async (customerName, phone, scheduleTime, address, remark, checkbox, deliveryType) => {
    if (hasPayment) {
      setLoading(true);
      let order = { pax: pax, data: cart, orderId: "SO_" + new Date().getTime(), customerName, phone, userId, scheduleTime, address, remark, checkbox, deliveryType, deliveryPrice, adCustomer };
      await sendOrderToPayment(order);
    } else {
      let order = { pax: pax, data: cart, orderId: "SO_" + new Date().getTime(), customerName, phone, userId, scheduleTime, address, remark, checkbox, deliveryType, deliveryPrice, adCustomer };
      await sendOrderToServer(order);
    };
  }
  const confirmDelivery = async () => {
    if (minimumConsumption != 0 && subtotal < minimumConsumption && deliveryType == 2) { // Minimum Consumption tip
      return minimumConsumptionTip();
    }
    setShowTk(true);
  }

  const sendOrderToPayment = async (order) => {
    setLoading(true);

    await axios.post('/v2/api/selfOrder/onlinePayment', order, { headers: { Authorization: "Bearer " + token } });
    orderRef.current.value = order.orderId;
    localStorage.setItem("orderId", order.orderId);
    localStorage.setItem("order", JSON.stringify(cart));
    if (paymentPlatform == 0) { //asiapay
      asiaPaySubmit.current.click();
    } else if (paymentPlatform == 1) { //hitpay
      let amount = ((subtotal *
        (1 + ((!isTakeAway && !paymentData.shouldExcludeDI) ? paymentData.serviceCharge : (isTakeAway && !paymentData.shouldExclude) ? paymentData.serviceCharge : 0)) *
        (1 + tax.tax) + deliveryPrice)).toFixed(2);
      let response = await axios.post('/v2/api/hitpay', { amount: amount, orderId: order.orderId }, { headers: { Authorization: "Bearer " + token } });
      if (response.status == 200) {
        clearCart();
        window.location.href = response.data.url;
      }
    } else if (paymentPlatform == 2) {
      let amount = ((subtotal *
        (1 + ((!isTakeAway && !paymentData.shouldExcludeDI) ? paymentData.serviceCharge : (isTakeAway && !paymentData.shouldExclude) ? paymentData.serviceCharge : 0)) *
        (1 + tax.tax) + deliveryPrice)).toFixed(2);
      let response = await axios.post('/v2/api/pocketPay', { amount: amount, orderId: order.orderId }, { headers: { Authorization: "Bearer " + token } });
      if (response.status == 200) {
        clearCart();
        window.location.href = response.data.url;
      }
    }
    clearCart();
  }
  const sendOrderToServer = async (order) => {
    await axios.post("/v2/api/selfOrder/order", order, { headers: { Authorization: "Bearer " + token } })
      .catch(function (error) {
        setError([{
          errorElement: "Warning",
          errorMessage: (
            <b style={{ color: "#CF000D" }}>{error.response.data.errorMsg}</b>
          )
        }])
        setShow(true);
      });
    await axios.get(`/v2/api/selfOrder/order?userId=${userId}&orderTime=${orderTime}&orderId=${order.orderId}`,
      { headers: { Authorization: "Bearer " + token } }
    )
      .then(function (response) {
        // handle success
        localStorage.setItem("orderId", order.orderId);
        setCartHistory(response.data.orderData);
        clearCart();
        setLoading(false);
        //push to success page
        navigate('/payment/success');
      })
      .catch(function (response) {
        // handle error
        console.log(response);
      });
  }

  useEffect(() => {
    let orderId = localStorage.getItem("orderId");
    axios.get(`/v2/api/selfOrder/order?userId=${userId}&orderTime=${orderTime}&orderId=${orderId}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        // handle success
        setCartHistory(response.data.orderData);
      })
      .catch(function (error) {
        // handle error
        console.log(error.response);
      });
  }, [orderTime, token, userId]);

  useEffect(() => {
    if (deliveryType == 0 || deliveryType == 1) {
      setDeliveryPrice(0);
      return;
    }
    deliveryCosts.map((item) => {
      if (subtotal >= item.minPrice && item.maxPrice > subtotal) {
        return setDeliveryPrice(item.deliveryPrice);
      }
    })
  }, [subtotal, deliveryType]);
  useEffect(() => {
    setSubtotal(getFinalPrice(cart));
  }, [cart]);

  useEffect(() => {
    let order = JSON.parse(localStorage.getItem("order"));
    if (order) {
      addToCart(order);
    }
  }, [addToCart]);
  useEffect(() => {
    setSubtotalHistory(getFinalPrice(cartHistory));
  }, [cartHistory]);

  // console.log(cart);
  // console.log("Tax+Payment");
  // console.log(tax);
  // console.log(paymentData);
  let serviceAmt = ((!isTakeAway && !paymentData.shouldExcludeDI) ? paymentData.serviceCharge : ((isTakeAway && !paymentData.shouldExclude) ? paymentData.serviceCharge : 0));
  if (typeof lanIndex === 'undefined') {
    return <></>
  }
  return (
    <BackgroundColor themeContext={themeContext}>
      {isLoading ? (
        <LoaderContainer>
          <Loader
            type="ThreeDots"
            color={themeContext.primaryColor}
            height="100"
            width="100"
          />
        </LoaderContainer>
      ) : (
        <React.Fragment>
          <CheckoutButton
            themeContext={themeContext}
            onClick={sendOrder}
            active={arrayBarState[0].active}
          >
            {arrayBarState[0].active ? languageContext[lanIndex].submit : languageContext[lanIndex].checkOut}
          </CheckoutButton>
          <HeaderContainer
            themeContext={themeContext}
            headerHeight={themeContext.headerHeight}
          >
            {/* <HeaderDisplay
              themeContext={themeContext}
              headerHeight={themeContext.headerHeight}
              image={company.companyLogo}
            /> */}
            <ArrayBar
              themeContext={themeContext}
              widthPercentage={"80%"}
              height={40}
              selectedColor={"#707070"}
              array={arrayBarState}
              setActiveState={setArrayBarState}
              produceNewState={produceArrayStateSingle}
              marginTop={15}
              bold={true}
              fontSize={14}
              lanIndex={lanIndex}
            />
          </HeaderContainer>
          <ArrowContainer themeContext={themeContext} headerHeight={themeContext.headerHeight}>
            <Link
              to="/menu"
              style={{ display: "grid", placeContent: "center" }}
            >
              <IoIosArrowBack
                color={themeContext.checkOutArrow}
                size={themeContext.headerHeight}
              />
            </Link>
          </ArrowContainer>
          <Buffer height={themeContext.headerHeight + 60} />
          <MenuTitleContainer
            themeContext={themeContext}
          >{`${returnMenuTitle()}`}</MenuTitleContainer>
          {arrayBarState[0].active ? (
            <React.Fragment>
              {cart.map((item, index) => {
                return (
                  <CheckoutPanel
                    key={index + item.title + item.codeId}
                    cart={cart}
                    handleDelete={handleDelete}
                    handleAdd={handleAdd}
                    handleMinus={handleMinus}
                    handleItemClick={handleItemClick}
                    index={index}
                    item={item}
                    height={height}
                    width={width}
                    lanIndex={lanIndex}
                    currencySymbol={currencySymbol}
                    deleteActive={arrayBarState[0].active}
                  />
                );
              })}
              <SubTotalWrapper>
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={width - 40}
                >

                  <LeftColumn>
                    {languageContext[lanIndex].subtotal}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{subtotal.toFixed(2)}
                  </RightColumn>

                </SubtotalAndTaxContainer>

                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={width - 40}
                >
                  <LeftColumn>
                    {languageContext[lanIndex].tax} {isTakeAway ? "" : `& ${languageContext[lanIndex].serviceCharge}`}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{(
                      subtotal *
                      (1 + serviceAmt) *
                      (1 + tax.tax) -
                      subtotal
                    ).toFixed(2)}
                  </RightColumn>
                </SubtotalAndTaxContainer>
                {/* } */}
                {deliveryType == 2 &&
                  <SubtotalAndTaxContainer
                    themeContext={themeContext}
                    width={width - 40}
                  >
                    <LeftColumn>
                      {languageContext[lanIndex].deliveryFee}
                    </LeftColumn>
                    <RightColumn>
                      {currencySymbol}&nbsp;{deliveryPrice.toFixed(2)}
                    </RightColumn>
                  </SubtotalAndTaxContainer>}

                <TotalContainer themeContext={themeContext} width={width - 40}>
                  <LeftColumn>
                    {languageContext[lanIndex].total}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{((deliveryPrice +
                      subtotal *
                      (1 + serviceAmt) *
                      (1 + tax.tax)
                    )).toFixed(2)
                    }
                  </RightColumn>
                </TotalContainer>
              </SubTotalWrapper>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {cartHistory.map((item, index) => {
                return (
                  <CheckoutPanel
                    key={item.codeId + index + item.title}
                    cart={cart}
                    handleDelete={handleDelete}
                    index={index}
                    item={item}
                    height={height}
                    width={width}
                    lanIndex={lanIndex}
                    deleteActive={arrayBarState[0].active}
                    currencySymbol={currencySymbol}
                  />
                );
              })}
              <div style={{ marginTop: 10 }}></div>
              <SubTotalWrapper>
                <SubtotalAndTaxContainer
                  themeContext={themeContext}
                  width={width - 40}
                >
                  <LeftColumn>
                    {languageContext[lanIndex].subtotal}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{subtotalHistory.toFixed(2)}
                  </RightColumn></SubtotalAndTaxContainer>
                {(paymentData.serviceCharge > 0 || tax.tax > 0) &&
                  <SubtotalAndTaxContainer
                    themeContext={themeContext}
                    width={width - 40}
                  >
                    <LeftColumn>
                      {languageContext[lanIndex].tax} {isTakeAway ? "" : `& ${languageContext[lanIndex].serviceCharge}`}
                    </LeftColumn>
                    <RightColumn>
                      {currencySymbol}&nbsp;{(

                        subtotalHistory *
                        (1 + serviceAmt) *
                        (1 + tax.tax) -
                        subtotalHistory
                      ).toFixed(2)}
                    </RightColumn>
                  </SubtotalAndTaxContainer>
                }
                <TotalContainer themeContext={themeContext} width={width - 40}>
                  <LeftColumn>
                    {languageContext[lanIndex].total}
                  </LeftColumn>
                  <RightColumn>
                    {currencySymbol}&nbsp;{
                      //subtotalHistory +
                      (
                        subtotalHistory *
                        (1 + serviceAmt) *
                        (1 + tax.tax)
                      ).toFixed(2)
                    }
                  </RightColumn>
                </TotalContainer>
                {((!isTakeAway && !paymentData.shouldExclude) || ((paymentData.serviceCharge > 0 && !paymentData.shouldExcludeDI) || tax.tax > 0)) &&
                  <DisclaimerContainer themeContext={themeContext} width={width - 40}>
                    *{languageContext[lanIndex].serviceChargeReminder}
                  </DisclaimerContainer>
                }
              </SubTotalWrapper>
            </React.Fragment>
          )}

          <Buffer height={180} />
        </React.Fragment>
      )}
      <form name="payFormCcard" method="post" action="
        https://test.paydollar.com/b2cDemo/eng/payment/payForm.jsp">
        <input type="hidden" name="merchantId" value="12108712" />
        <input type="hidden" name="amount" value={
          ((deliveryPrice + subtotal *
            (1 + serviceAmt) *
            (1 + tax.tax))).toFixed(2)}
        />
        <input type="hidden" name="orderRef" value="123" ref={orderRef} />
        <input type="hidden" name="currCode" value="702" />
        <input type="hidden" name="mpsMode" value="NIL" />
        <input type="hidden" name="successUrl"
          value="https://selforder.ireachfnb.com/payment/success" />
        <input type="hidden" name="failUrl" value="https://selforder.ireachfnb.com/payment/fail" />
        <input type="hidden" name="cancelUrl"
          value="https://selforder.ireachfnb.com/payment/cancel" />
        <input type="hidden" name="payType" value="N" />
        <input type="hidden" name="lang" value="E" />
        <input type="hidden" name="payMethod" value="ALL" />
        <input type="hidden" name="secureHash" value="" />
        <input type="hidden" name="remark" value={company.shortName} />
        <input type="submit" name="submit" style={{ display: "none" }} ref={asiaPaySubmit} />
      </form>
      <Modal show={show} setShow={setShow} error={error} />
      <ConfirmCheckOutModal show={showConfirm} setShow={setShowConfirm} confirmCheckOut={confirmToCheckout} lanIndex={lanIndex} />
      <TakeAwayModal show={showTk} setShowTk={setShowTk} deliveryType={deliveryType} confirmTKCheckOut={confirmTKCheckOut} lanIndex={lanIndex} />
      <DeliveryOrNotModal show={showDelive} setShowDelive={setShowDelive} type={deliveryType} setDeliveryType={setDeliveryType} deliveryOrNot={deliveryOrNot}
        confirmDelivery={confirmDelivery} lanIndex={lanIndex} deliveryPrice={deliveryPrice} currencySymbol={currencySymbol} includeDineIn={includeDineIn} tkDiMenuDiff={tkDiMenuDiff} />
      <PaymentTypeModal show={showPayment} setShow={setShowPayment} payType={payType} setPayType={setPayType} lanIndex={lanIndex}
        confirmPTCheckOut={confirmPTCheckOut} total={arrayBarState[0].active ? (deliveryPrice + subtotal).toFixed(2) : subtotalHistory.toFixed(2)} />
      <EditItemModal show={showEdit} item={editItem} index={editIndex} setShow={setShowEdit} cart={cart} />
    </BackgroundColor>
  );
};

export default Checkout;

//Styled Components
const BackgroundColor = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.themeContext.backgroundColor};
  overflow-y: scroll;
  z-index: -10;
`;
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 0rem;
  left: 0rem;
  top: 0rem;
  flex-direction: column;
  height: ${(props) => props.headerHeight + 35}px;
  background-color: ${(props) => props.themeContext.secondaryColor};
  z-index: 5;
  box-shadow: 0px 1px 3px rgba(0,0,0, 45%);
`;
const HeaderDisplay = styled.div`
  display: grid;
  text-align: center;
  background-color: ${(props) => props.themeContext.primaryColor};
  place-content: center;
  align-self: center;
  width: 100%;
  height: ${(props) => props.headerHeight}px;
  //Adjust the image height to be adjusted based on the screen size at a later date.
  background-image: url(${(props) => props.image});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;
const ArrowContainer = styled.div`
  position: fixed;
  place-content: center;
  z-index: 10;
  width: 10%;
  height: ${(props) => props.headerHeight + 35}px;
  display: flex;
`;

const CheckoutButton = styled.div`
  display: ${(props) => (props.active ? "grid" : "none")};
  position: fixed;
  bottom: 10px;
  left: 20px;
  right: 20px;
  text-align: center;
  color: ${(props) => props.themeContext.cartFont};
  font-size: 18px;
  font-family: ${(props) => props.themeContext.fontFamily};
  background-color: ${(props) => props.themeContext.cartColor1};
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 7px;
  box-shadow: 0px 0px 6px rgb(0 0 0 / 70%);
  z-index: 3;

  animation: moveBox 1.8s infinite;
  @keyframes moveBox {
    
    0%  {
      box-shadow: 1px 1px 3px rgb(0 0 0 / 70%);
      transform: translateX(0px);
    }
    50%   {
      box-shadow: 1px 1px 13px rgb(0 0 0 / 100%);
      transform: translateX(5px);
    }
    100%  {
      box-shadow: 1px 1px 3px rgb(0 0 0 / 70%);
      transform: translateX(0px);
    }
    
  }

`;

const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  place-content: center;
`;

const MenuTitleContainer = styled.div`
  display: block;
  font-size: 16px;
  font-weight: bold;
  color: ${(props) => props.themeContext.fontPrimary};
  font-family: ${(props) => props.themeContext.fontFamily};
  margin-left: 20px;
  margin-bottom: 10px;
  margin-top: 0px;
  text-decoration: underline;
`;

const Buffer = styled.div`
  display: block;
  height: ${(props) => props.height}px;
`;
const SubTotalWrapper = styled.div`
  display: grid;
  place-content: center;
`;
const SubtotalAndTaxContainer = styled.div`
  display: flex;
  color: ${(props) => props.themeContext.fontPrimary};
  font-family: ${(props) => props.themeContext.fontFamily};
  width: ${(props) => props.width}px;
  font-weight: 500;
  font-size: 14px;
  padding-bottom: 4px;
`;
const LeftColumn = styled.div`
  flex-grow: 1;
`;
const RightColumn = styled.div`
  text-align: right;
`;
const TotalContainer = styled.div`
  display: flex;
  /*color: ${(props) => props.themeContext.fontPrice};*/
  font-family: ${(props) => props.themeContext.fontFamily};
  
  width: ${(props) => props.width}px;
  font-weight: 700;
  font-size: 18px;
`;

const DisclaimerContainer = styled.div`
  text-align: right;
  color: ${(props) => props.themeContext.fontPrimary};
  font-family: ${(props) => props.themeContext.fontFamily};
  width: ${(props) => props.width}px;

  font-weight: 500;
  font-size: 12px;
`;
